import axios from "axios";
import { config } from "../config";
import { getAuthHeader } from "../customAuth/authContext";
import User from "../users/user";


export const getAllUsers = async (): Promise<User[]> => {
    try {
        const response = await axios.get(`${config.apiServerUrl}/user/all`, {
            headers: {
                Authorization: getAuthHeader()
            }
        });
        if (response.status === 200) {
            return response.data as User[];
        }
        else {
            throw new Error("Failed to fetch users");
        }
    } catch (error) {
        console.error("Error fetching users", error);
        return [];
    }
};

export const addUserApi = async (model: any) => {
    try {
        const response = await axios.post(`${config.apiServerUrl}/user/add`, model, {
            headers: {
                Authorization: getAuthHeader()
            }
        });
        return response.data;
    } catch (error) {
        console.error("Error adding user", error);
        throw error;
    }
};

export const editUserApi = async (model: any) => {
    try {
        const response = await axios.put(`${config.apiServerUrl}/user/edit`, model, {
            headers: {
                Authorization: getAuthHeader()
            }
        });
        return response.data;
    } catch (error) {
        console.error("Error editing user", error);
        throw error;
    }
};

export const deleteUserApi = async (model: any) => {
    try {
        const response = await axios.delete(`${config.apiServerUrl}/user/delete`, {
            data: model,
            headers: {
                Authorization: getAuthHeader()
            }
        });
        return response.data;
    } catch (error) {
        console.error("Error deleting user", error);
        throw error;
    }
};